import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor, TERTIARY } from '@tornado-rdk/theme';

export const STROKE_COLOR = makeThemeColor(PRIMARY);

export const INNER_COLOR = makeThemeColor(TERTIARY);

export const FILL_SELECTED_COLOR = makeThemeColor(PRIMARY);

export const FILL_UNFOCUSED_COLOR = makeThemeColor(PRIMARY, 0.1);

export const TEXT_COLOR = makeThemeColor(PRIMARY);

export const FILL_FOCUSED_COLOR = makeThemeColor(PRIMARY, 0.3);

export const TEXT_SELECTED_COLOR = makeThemeColor(TERTIARY);

export const CONTENT_GAP = {
  [HD]: 12,
  [FULL_HD]: 12,
};
